import { Route} from '@angular/router';
import { NoteEventsComponent } from './notes/note-events/note-events.component';
import {DocumentEventsComponent} from './documents/document-events/document-events.component';
import {ContactsEventsComponent} from './contacts/contacts-events/contacts-events.component';
import {AddressEventsComponent} from './address/address-events/address-events.component';
import {ReviewsComponent} from './reviews/reviews.component';
// import { AddTimingComponent } from './facility-timings/add-timing/add-timing.component';
import { AddHolidaysComponent } from './holidays/add-holidays/add-holidays.component';
import { TimingsComponent } from './facility-timings/timings/timings.component';

/**
 * Mailbox custom route matcher
 *
 * @param url
 */
export const entityRoutes: Route[] = [
    { path      : 'event-notes',  component: NoteEventsComponent, pathMatch : 'full'},
    { path      : 'event-documents',  component: DocumentEventsComponent, pathMatch : 'full'},
    { path      : 'event-contacts',  component: ContactsEventsComponent, pathMatch : 'full'},
    { path      : 'event-address',  component: AddressEventsComponent, pathMatch : 'full'},
    { path      : 'event-review',  component: ReviewsComponent, pathMatch : 'full'},
    { path      : 'event-timings',  component: TimingsComponent, pathMatch : 'full'},
    { path      : 'event-holidays',  component: AddHolidaysComponent, pathMatch : 'full'},
    ];

